import React, { Fragment, memo } from "react";
import PropTypes from "prop-types";
import Row from "../../../../../Common/Row";
import Table from "../../../../../Common/Table";
const Rows = memo(({ subscription }) => {
	return (
		<Fragment>
			<Row label={`Subscription state`} value={subscription.subscriptionState} />
			<Row label={`Brand`} value={subscription.brand} />
			<Row label={`Lifetime subscription`} value={subscription.isLifeSubscription} />
			<Row label={`Update required`} value={subscription.updateRequired} />
			<Row label={`Terms of use`} value={subscription.toU} />
			<Row label={`Created on`} value={subscription.dateCreated} />
			<Row label={`Modified on`} value={subscription.dateModified} />
			<Row label={`Cancelled on`} value={subscription.dateCancelled} />
			<Row label={`Start date`} value={subscription.startDate} />
			<Row label={`End date`} value={subscription.endDate} />
		</Fragment>
	);
});

const Subscription = memo(({ subscription }) => {
	const icon = subscription.active ? `glyphicon glyphicon-ok` : `glyphicon glyphicon-remove`;
	const status = subscription.active ? `active` : `inactive`;

	return (
		<Table
			title={`Subscription details - ${subscription.productName}`}
			icon={icon}
			colorClass={`subscription-${status}`}
			iconHoverText={`Subscription is ${status}`}
		>
			<Rows subscription={subscription} />
		</Table>
	);
});
Rows.displayName = `Rows`;
Rows.propTypes = {
	subscription: PropTypes.object.isRequired
};
Subscription.displayName = `Vehicle`;
Subscription.propTypes = {
	subscription: PropTypes.object.isRequired
};

export default Subscription;
